export const MasterType = {
  Person: 1, // 个人
  Star: 5 // 明星
}

export const PersonalCodeStatus = {
  Valid: 0,
  Invalid: 1,
}

export const StarCodeStatus = {
  NotStart: 0,
  Valid: 1,
  Ended: 2,
}

export const EggType = {
  Normal:0, // 普通蛋
  Yoo:1, // Yoo蛋
  Trick:2, // 小捣蛋
  YooTrick:3, // Yoo小捣蛋
  Star:5 // 明星蛋
}

export const PropertyBelong = {
  Normal:0, // 正常情况
  Guest:1, // 全归客人
  Master:2, // 全归主人
  Exchange:3, // 互相交换
}